import sitesBR from './sites.br';
import sitesCL from './sites.cl';
import sitesCO from './sites.co';
import sitesMX from './sites.mx';
import sitesAR from './sites.ar';

const locales = {
  BR: sitesBR,
  CL: sitesCL,
  CO: sitesCO,
  MX: sitesMX,
  AR: sitesAR,
};

export default locales;
